module.exports = __webpack_public_path__ + "img/white_paper2.3a68f25f.png";